export { State, Getter, Action, Mutation, namespace } from './bindings';



//////////////////
// WEBPACK FOOTER
// ./~/vuex-class/lib/index.js
// module id = 49
// module chunks = 0